jQuery(document).ready( function($) {

	/**************
	NAV MENU HOVER BG COLOR CHANGE
	**************/


		$('#menu-main-menu li a').on('hover', function() {
			var title = $(this).attr('title');
			if ( title ) {
				$('.off-canvas-bg-color').toggleClass(title);
			} else {
				$('.off-canvas-bg-color').toggleClass('grey');
			}
		});


		$('#menu-sub-main-utility li a').on('hover', function() {
			$('.off-canvas-bg-color').toggleClass('grey');
		});


var screenW = jQuery( window ).width();

	/**************
	HAMBURGER OPEN + CLOSE STATE
	**************/
		setTimeout(function() {
		    	jQuery('#hamburger').click(function() {
					jQuery(this).toggleClass('open');
				})
		    }, 3000);

		if(screenW < 1000) {
		$('button#hamburger').click(function() {
			$('.off-canvas-wrapper').toggleClass('rPos');
		})
	};




});